import {
    DND_TRANSITION_HANDLE_LEFT,
    DND_TRANSITION_HANDLE_RIGHT
} from "pages/editor/lib/timeline";
import styled from "styled-components";

const handleSide = (props) => {
    if (props.side === DND_TRANSITION_HANDLE_LEFT) {
        return `left: 0;`;
    }
    if (props.side === DND_TRANSITION_HANDLE_RIGHT) {
        return `right: 0;`;
    }
};
export const TransitionsContainerWrapper = styled.div`
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    overflow: hidden;
    position: absolute;
`;

export const TransitionIcon = styled.div.attrs((props) => ({
    ...(props.active && {
        style: {
            backgroundColor: props.theme.transitionBgActive
        }
    })
}))`
    width: 17px;
    height: 17px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border-radius: 3px;
    background: ${(props) => props.theme.transitionBg}
        url(${(props) => props.iconUrl}) center;
    background-size: contain;
`;

export const TransitionWrapper = styled.div.attrs((props) => ({
    ...(props.active && {
        style: {
            background: props.theme.transitionBgTransparentActive
        }
    })
}))`
    height: 55%;
    top: 0;
    bottom: 0;
    margin: auto;
    background: ${(props) => props.theme.transitionBgTransparent};
    position: absolute;
    border-radius: 5px;
    overflow: hidden;
    z-index: 5;
`;

export const Handle = styled.div.attrs((props) => ({
    ...(props.active && {
        style: {
            opacity: 1,
            background: props.theme.transitionBgActive
        }
    })
}))`
    ${(props) => handleSide(props)}
    width: ${(props) => props.theme.assetHandleWidth}px;
    height: 100%;
    position: absolute;
    cursor: ew-resize;
    background-color: ${(props) => props.theme.transitionBg};
    opacity: 0;

    &:hover {
        opacity: 1;
    }
`;
